"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlexContainer = exports.CashBackLabel = exports.CashBackIconLayout = exports.CashBackCustomIcon = exports.CashBackContainer = exports.CashBackAmount = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var CashBackContainer = exports.CashBackContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__CashBackContainer",
  componentId: "sc-1g6aitd-0"
})(["display:flex;align-items:center;background-color:", ";border-radius:20px 8px;color:#5d6fb4;line-height:1.4;font-size:", "px;padding:0 8px;", " &.column{display:block;padding:3px 5px 2px 8px;line-height:12px;border-radius:12px 8px;}"], function (_ref) {
  var withAvatar = _ref.withAvatar;
  return withAvatar ? '#f3f3f3' : '#fff';
}, function (_ref2) {
  var size = _ref2.size;
  return size === 'l' ? 12 : 10;
}, function (_ref3) {
  var withBorder = _ref3.withBorder;
  return withBorder && 'border: 1px solid;';
});
var CashBackLabel = exports.CashBackLabel = _styledComponents["default"].span.withConfig({
  displayName: "styles__CashBackLabel",
  componentId: "sc-1g6aitd-1"
})(["margin-right:3px;"]);
var CashBackAmount = exports.CashBackAmount = _styledComponents["default"].b.withConfig({
  displayName: "styles__CashBackAmount",
  componentId: "sc-1g6aitd-2"
})(["padding-top:2.5px;padding-bottom:2.5px;font-size:1.072em;.column &{margin-left:1px;}.super-cashback &{font-size:1em;}"]);
var CashBackIconLayout = exports.CashBackIconLayout = _styledComponents["default"].div.withConfig({
  displayName: "styles__CashBackIconLayout",
  componentId: "sc-1g6aitd-3"
})(["align-items:center;display:flex;margin-left:3px;.super-cashback &{margin-top:-5px;margin-left:-3px;}"]);
var CashBackCustomIcon = exports.CashBackCustomIcon = _styledComponents["default"].img.withConfig({
  displayName: "styles__CashBackCustomIcon",
  componentId: "sc-1g6aitd-4"
})(["max-height:14px;max-width:14px;width:100%;display:block;"]);
var FlexContainer = exports.FlexContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__FlexContainer",
  componentId: "sc-1g6aitd-5"
})(["display:flex;"]);